import { defaultFraxtalProviderConfiguration } from '../default-constants';

export const FRAXSWAP_V2_CONTRACT_ADDRESS = '0x2Dd1B4D4548aCCeA497050619965f91f78b3b532';
export const FRAXSWAP_V2_PROVIDER_CONFIGURATION = defaultFraxtalProviderConfiguration;
